import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {createPortal} from 'react-dom';

/**
 * Used to wrap an an element in an IFrame
 * This can be useful for style encapsulation, this way any content inside the IFrame won't be affected by outer css.
 * You can also control if scripts are allowed to run, popups etc..
 * 
 * This uses HTML5 sandbox feature - if you want to add more permissions
 * reference - https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-sandbox
 * 
 * @param {Object} params
 * @param {Node} params.children
 * @param {String} params.title
 * @param {String} [params.allowSameOrigin]
 * @param {String} [params.allowScripts]
 * @param {String} [params.allowPopups]
 * @param {String} [params.allowDownloads]
 * @param {String} [params.src]
 */
function SMCIFrame({
    children,
    title,
    allowSameOrigin=true,
    allowScripts=false,
    allowPopups=false,
    allowDownloads=false,
    noSandbox,
    src,
    ...rest
}) {
  const [contentRef, setContentRef] = useState(null);
  const mountNode = contentRef && contentRef.contentWindow.document.body;

  const sandboxString = [
    allowSameOrigin ? 'allow-same-origin' : '',
    allowScripts ? 'allow-scripts' : '',
    allowPopups ? 'allow-popups' : '',
    allowDownloads ? 'allow-downloads' : ''
  ].join(' ');


  return (
    <iframe sandbox={noSandbox ? undefined : sandboxString} src={src} {...rest} title={title} ref={setContentRef}>
      {children && mountNode &&
        createPortal(
          React.Children.only(children),
          mountNode
        )}
    </iframe>
  );
}

SMCIFrame.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired
}

export default SMCIFrame;